import {
    getData,
    postData,
    patchData,
    deleteData
} from './Services'

export const getPresentacionesLista = async () => {
    const res = await getData('/presentacion/presentacion_select');
    return res
}

export const getPresentacionesPanel = async (searchTerm, page, perPage) => {
    let queryParams = [];
    if (searchTerm) {
        queryParams.push(`pre_descripcion=${encodeURIComponent(searchTerm || '')}`);
    }
    if (page) {
        queryParams.push(`page=${encodeURIComponent(page || 1)}`);
    }
    if (perPage) {
        queryParams.push(`perPage=${encodeURIComponent(perPage || 10)}`);
    }
    const queryString = queryParams.length > 0 ? `?&${queryParams.join('&')}` : '';
    return await getData("/presentacion", queryString);
};

export const getPresentacionById = async (id) => {
    const res = await getData(`/presentacion/${id}`)
    return res
}

 
export const postPresentacion = async (body) => {
    const res = await postData('/presentacion', body)
    return res
}

export const patchPresentacion = async (id, body) => {
    const res = await patchData(`/presentacion/${id}`, body)
    return res
}

export const deletePresentacion = async (id) => {
    const res = await deleteData(`/presentacion/${id}`)
    return res
}